import React, { Component } from "react";
import { Table, Spin, message } from "antd";
import { formatCurrency } from "utilities";
import PropTypes from "prop-types";
import { CompanyService } from "../../services";
import { CASE_DB_DEVIATIONS_COLUMNS } from "constants/table-columns";
import { List } from "immutable";
import {Table as DynamicTable} from 'components';
import { STATE_STATUS } from "../../constants";

let columnsDbView = [];
class DbView extends Component {

    state = {
        dbViewTableData: [],
        dbViewTableColumns: [],
        loading: false,
        dbViewApiData: {},
        anchorViewObj:{
            loadingAnchorView: false,
            anchorViewApiData: {},
            anchorViewDataFetched: false,
            anchorViewData: [],
            anchorViewTableColumns: [
                { title: "S.No.", dataIndex: "s_no", key: "s_no", width: 50, align: "center" },
                { title: "Parameters - Anchor", dataIndex: "parameters_anchor", key: "parameters_anchor", align: "center", width: 200,
                    render: (text) => {
                        return {
                            props: {
                                style: {textAlign: "start"
                                },
                            },
                            children: <div>{text}</div>
                        };
                    }
                },
            ],
        },
        geoViewObj:{
            loadingGeoView: false,
            geoViewApiData: {},
            geoViewDataFetched: false,
            geoViewData: [],
            geoViewTableColumns: [
                { title: "S.No.", dataIndex: "s_no", key: "s_no", width: 50, align: "center" },
                { title: "Parameters - Geo", dataIndex: "parameters_anchor", key: "parameters_anchor", align: "center", width: 200,
                    render: (text) => {
                        return {
                            props: {
                                style: {textAlign: "start"
                                },
                            },
                            children: <div>{text}</div>
                        };
                    }
                },
                { title: "Values", dataIndex: "value_anchor", key: "value_anchor", align: "center", width: 200,
                    render: (text) => {
                        return {
                            props: {
                                style: {textAlign: "center",
                                },
                            },
                            children: <div>{text}</div>
                        };
                    }
                },
            ],
        },
        stateViewObj:{
            loadingStateView: false,
            stateViewApiData: {},
            stateViewDataFetched: false,
            stateViewData: [],
            stateViewTableColumns: [
                { title: "S.No.", dataIndex: "s_no", key: "s_no", width: 50, align: "center" },
                { title: "State View Parameters", dataIndex: "para", key: "para", width: 250, align: "center",
                    render: (text) => {
                        return {
                            props: {
                                style: {textAlign: "start"
                                },
                            },
                            children: <div>{text}</div>
                        };
                    } },
                { title: "Value - Overall", dataIndex: "overall", key: "overall", width: 200, align: "center" },
            ],
        },
        deviationListLoader : false,
        dbDeviationList: [],
        anchorViewTableData: [],
        geoViewTableData: [],
        stateViewTableData: []
    }

    componentDidMount(){
        if(this.props.caseId){
            CompanyService.getCreditEnhancementDbView(this.props.caseId)
                .then(({ data }) => {
                    this.setState({ dbViewApiData: data }, () => {
                        this.creditEnhancementDbViewFn();
                    });
                })
                .catch((err) => {
                    console.error("API call failed:", err);
                });
            CompanyService.getAnchorView(this.props.caseId).then(({data}) => {
                    this.setState({anchorViewTableData: data && data?.data} , () => {
                        this.anchorViewFn();
                    });
                }).catch((err) => {
                    // message.error(err && Object.values(err) && Object.values(err)[0]|| "Something went wrong");
                });
            CompanyService.getGeoView(this.props.caseId).then(({data}) => {
                    this.setState({geoViewTableData: data && data?.data} , () => {
                        this.geoViewFn();
                    });
                    // data && data.message && message.error(data.message);
                }).catch(() => {
                    // message.error("Something went wrong");
                });

            CompanyService.getStateView(this.props.caseId).then(({data}) => {
                    this.setState({stateViewTableData: data} , () => {
                        this.stateViewFn()
                    });
                    // data && data.message && message.error(data.message);
                }).catch(() => {
                    // message.error("Something went wrong");
                });
        }
        const seller_ids = this.props.caseDetail.get('sellers').map(_ => _.id);
        CompanyService.getDeviationsList(seller_ids)
            .then(({ data }) => {
                this.setState({
                    dbDeviationList: data,
                    deviationListLoader: false

                })
            })
            .catch((err) => {
                this.setState({
                    dbDeviationList: [],
                    deviationListLoader: false

                })
            })
    }

    componentDidUpdate(){
        // if(this.state.dbViewApiData != this.props.dbViewTableData){
        //     this.creditEnhancementDbViewFn();
        // }
        // if(this.props.anchorViewTableData && this.state.anchorViewObj["anchorViewApiData"] != this.props.anchorViewTableData && this.state.anchorViewObj["anchorViewDataFetched"] === false){
        //     this.anchorViewFn();
        // }
        // if(this.props.geoViewTableData && this.state.geoViewObj["geoViewApiData"] != this.props.geoViewTableData && this.state.geoViewObj["geoViewDataFetched"] === false){
        //     this.geoViewFn();
        // }
        // if(!Array.isArray(this.props.stateViewTableData) && this.state.stateViewObj["stateViewApiData"] != this.props.stateViewTableData && this.state.stateViewObj["stateViewDataFetched"] === false){
        //     this.stateViewFn();
        // }
    }
    creditEnhancementDbViewFn = () => {
        const {db_details, ...newData} = this.state.dbViewApiData;
        this.setState({loading:true});
        const dynamicColumns = db_details && Object.entries(db_details);
        const dbViewDataApi = newData && Object.values(newData);
        const dbViewData = [];
        columnsDbView = [
            { title: "S.No.", dataIndex: "s_no", key: "s_no", width: 50, align: "center" },
            { title: "Parameters for DB", dataIndex: "parameters_db", key: "parameters_db", align: "center", width: 200,
                render: (text, record) => {
                    return {
                        props: {
                            style: {textAlign: "start",
                                color: ["10", "11", "12"].includes(record.s_no) && "#F21717"
                            },
                        },
                        children: <div>{text}</div>
                    };
                }
            },
            // { title: "Gating/ Scoring Parameter", dataIndex: "gating_scoring_parameters", key: "gating_scoring_parameters", align: "center" },
        ];
        dynamicColumns && dynamicColumns.map(el=>{
            columnsDbView.splice( columnsDbView.length, 0,
                {   title: el[1] || "--",
                    dataIndex: el[0] || "--",
                    key: el[0] || "--",
                    align: "center",
                    width: 200,
                    render(text, record) {
                        return {
                            props: {
                                style: { background: 
                                        record?.pass_fail_output === "Pass" ? "#D9D9D961": record?.pass_fail_output === "Fail" ? "#D32A2A33" : "#D9D9D961",
                                border: ["Pass", "Fail"].includes(record?.pass_fail_output) ? "1px solid rgb(215 218 227)" : "1px solid rgb(226 229 235)"
                                }
                            },
                            children: <div>{Array.isArray(text) ? text.join() : typeof text == "object" ? `${formatCurrency(text.closing_balance_lakhs, false)}  ${"(" + text.perc_closing_balance + "%)"}` :   text}</div>
                        };
                    }

                });
        });
        dbViewDataApi.map(el=>{
            const dbValues = el.values || [];
            const dbValuesObj = {};
            dbValues.map((elem)=>{
                return(
                    dbValuesObj[elem.gstin]= (["6", "7", "7a", "8", "9", "10", "11"].includes(el.s_no) && elem.value.closing_balance_lakhs  && typeof elem.value.closing_balance_lakhs === "number" && elem.value.closing_balance_lakhs >0 ) ? `${formatCurrency(elem.value.closing_balance_lakhs, false)} ${(["8", "9", "10", "11"].includes(el.s_no) && elem.value.perc_closing_balance) && "(" + elem.value.perc_closing_balance + "%)"}`: elem.value,
                    dbValuesObj["pass_fail_output"]= elem?.pass_fail_output
                );});
            dbViewData.push({
                "s_no": el?.s_no,
                "parameters_db": el?.par_db,
                // "gating_scoring_parameters": el?.gating_scoring_parameters,
                ...dbValuesObj
            });
        });
        this.setState({dbViewTableColumns: columnsDbView, dbViewTableData: dbViewData, loading: false});
    }

    anchorViewFn = () => {
        const newData = this.state.anchorViewTableData;
        this.setState(prevState =>  ({
            ...prevState,
            anchorViewObj:{
                ...prevState.anchorViewObj,
                loadingAnchorView: true,
                anchorViewApiData: newData,
                anchorViewDataFetched: true,
            }}));
        const branchViewDataApi = newData && Object.values(newData);
        const dynamicColumns = branchViewDataApi && branchViewDataApi[0] && branchViewDataApi[0].values || [];
        const branchViewData = [];
        const anchorViewDynamicCol = [];
        dynamicColumns && dynamicColumns.forEach(el=>{
            anchorViewDynamicCol.push(
                {   title: "Values" || "--",
                    dataIndex: el.gstin || "--",
                    key: el.gstin || "--",
                    align: "center",
                    width: 200,
                    render(text) {
                        return {
                            props: {
                                style: { background: 
                                    text?.pass_fail_output === "Pass" ? "#D9D9D961": text?.pass_fail_output === "Fail" ? "#D32A2A33" : "#D9D9D961",
                                border: ["Pass", "Fail"].includes(text?.pass_fail_output) ? "1px solid rgb(215 218 227)" : "1px solid rgb(226 229 235)"
                                }
                            },
                            children: <div>{text.value}</div>
                        };
                    }
    
                });
        });
        branchViewDataApi && branchViewDataApi.map((el, idx)=>{
            const anchorBranchValues = el.values || [];
            const dbValuesObj = {};
            anchorBranchValues.map((elem)=>{
                return(
                    dbValuesObj[elem.gstin]= elem
                );});
            branchViewData.push({
                "s_no": idx+1,
                "parameters_anchor": el?.par_db,
                ...dbValuesObj
            });
        });
        this.setState(prevState => {
            return(({
                ...prevState,
                anchorViewObj: {
                    ...prevState.anchorViewObj,
                    loadingAnchorView: false,
                    anchorViewTableColumns: [...prevState.anchorViewObj.anchorViewTableColumns, ...anchorViewDynamicCol], 
                    anchorViewData: branchViewData,
                    anchorViewDataFetched: false,
                },
            }));});
    }

    geoViewFn = () => {
        const newData = this.state.geoViewTableData;
        this.setState(prevState => ({
            ...prevState,
            geoViewObj:{
                ...prevState.geoViewObj,
                loadingGeoView: true,
                geoViewApiData: newData,
                geoViewDataFetched: true,
            },
        }));
        const branchViewDataApi = newData && Object.values(newData);
        const branchViewData = [];
        branchViewDataApi && branchViewDataApi.forEach((el, idx)=>{
            branchViewData.push({
                "s_no": idx+1,
                "parameters_anchor": el?.par_db,
                "value_anchor": el?.values && el.values[0] && el.values[0].value,
            });
        });
        this.setState(prevState => ({
            ...prevState,
            geoViewObj: {
                ...prevState.geoViewObj,
                loadingGeoView: false,
                geoViewData: branchViewData,
                geoViewDataFetched: false,
            },
        }));
    }

    stateViewFn = () => {
        const newData = this.state.stateViewTableData;
        this.setState(prevState =>  ({
            ...prevState,
            stateViewObj:{
                ...prevState.stateViewObj,
                loadingStateView: true,
                stateViewApiData: newData,
                stateViewDataFetched: true,
            }}));
        if(newData && newData.message){
            message.error(newData.message || "Something went wrong");
            this.setState(prevState =>  ({
                ...prevState,
                stateViewObj:{
                    ...prevState.stateViewObj,
                    loadingStateView: false,
                }}));
            return;
        }
        const stateViewDataApi = newData && newData.data && Object.values(newData.data) || [];
        if(stateViewDataApi.length>0){
            const stateViewColumnsData = newData && newData.columns || [];
            const stateViewData = [];
            const stateViewDynamicCol = [];
            stateViewColumnsData && (Object.keys(stateViewColumnsData)).forEach(el=>{
                const element = stateViewColumnsData[el];
                if(el === "state_name"){
                    const stateObj = this.state.stateViewObj && this.state.stateViewObj["stateViewTableColumns"].find(el=>el.key === "para");
                    stateObj.title = `State View Parameters - ${element}`;
                }
                if(el === "industry"){
                    stateViewDynamicCol.push(
                        {   title: `Industry - ${Array.isArray(element) && element?.toString()}`,
                            dataIndex: el,
                            key: el,
                            align: "center",
                            width: 200,
                        }
                    );
                }
                if(el === "anchors"){
                    element.forEach(anchor => {
                        stateViewDynamicCol.push(
                            {   title: `Anchor - ${anchor.name}` || "--",
                                dataIndex: anchor.gstin,
                                key: anchor.gstin,
                                align: "center",
                                width: 200,
                            }
                        );
                    });
                }
            });
            stateViewDataApi && stateViewDataApi.map((el, idx)=>{
                const stateBranchValues = el.values || [];
                const dbValuesObj = {};
                stateBranchValues.forEach((elem, idx)=>{
                    // fetch first obj value as "Overall value" column
                    if(idx === 0){
                        dbValuesObj["overall"] = elem.value;
                    } 
                    // Second obj value is industry and rest are anchors
                    if(idx === 1){
                        dbValuesObj["industry"] = elem.value;
                    } 
                    return(
                        dbValuesObj[elem.gstin]= elem.value
                    );});
                stateViewData.push({
                    "s_no": idx+1,
                    "para": el.par_db,
                    ...dbValuesObj
                });
            });
            this.setState(prevState => {
                return(({
                    ...prevState,
                    stateViewObj: {
                        ...prevState.stateViewObj,
                        loadingStateView: false,
                        stateViewTableColumns: [ ...prevState.stateViewObj.stateViewTableColumns , ...stateViewDynamicCol], 
                        stateViewData: stateViewData,
                        stateViewDataFetched: false,
                    },
                }));});
        }
    }



    render(){
        return (
            <>
            <Spin spinning={this.state.loading}>
                {this.state.dbViewTableData && this.state.dbViewTableColumns &&
            <Table
                bordered 
                className="components-table-demo-nested p-10 ant-col padless-card"
                columns={this.state.dbViewTableColumns}
                dataSource={this.state.dbViewTableData && this.state.dbViewTableData}
                size="middle"
                loading={this.state.loading}
                pagination={false}
            />
                }
            </Spin>
            <Spin spinning={this.state.anchorViewObj["loadingAnchorView"]}>
                {this.state.anchorViewObj["anchorViewData"] && this.state.anchorViewObj["anchorViewTableColumns"] &&
            <Table
                bordered 
                className="components-table-demo-nested p-10 ant-col padless-card"
                columns={this.state.anchorViewObj["anchorViewTableColumns"]}
                dataSource={this.state.anchorViewObj["anchorViewData"]}
                size="middle"
                loading={this.state.anchorViewObj["loadingAnchorView"]}
                pagination={false}
            />
                }
            </Spin>
            <Spin spinning={this.state.stateViewObj["loadingStateView"]}>
                {this.state.stateViewObj["stateViewData"] && this.state.stateViewObj["stateViewTableColumns"] &&
            <Table
                bordered 
                className="components-table-demo-nested p-10 ant-col padless-card"
                columns={this.state.stateViewObj["stateViewTableColumns"]}
                dataSource={this.state.stateViewObj["stateViewData"]}
                size="middle"
                loading={this.state.stateViewObj["loadingStateView"]}
                pagination={false}
            />
                }
            </Spin>
            <Spin spinning={this.state.geoViewObj["loadingGeoView"]}>
                {this.state.geoViewObj["geoViewData"] && this.state.geoViewObj["geoViewTableColumns"] &&
            <Table
                bordered 
                className="components-table-demo-nested p-10 ant-col padless-card"
                columns={this.state.geoViewObj["geoViewTableColumns"]}
                dataSource={this.state.geoViewObj["geoViewData"]}
                size="middle"
                loading={this.state.geoViewObj["loadingGeoView"]}
                pagination={false}
            />
                }
            </Spin>
                <Spin spinning={this.state.deviationListLoader}>
                    <div className="components-table-demo-nested p-10 ant-col padless-card">
                    <DynamicTable
                        loading={this.state.deviationListLoader}
                        showHeader={false}
                        showFooter={false}
                        pagination={false}
                        showTopSection={false}
                        noRowSelection
                        columns={CASE_DB_DEVIATIONS_COLUMNS(this.props.all_enums.get("status") == STATE_STATUS.FETCHED ? this.props.all_enums.getIn(['data' , "deviation_types"]) : [])}
                        data={List(this.state.dbDeviationList)}
                    />
                    </div>
                </Spin>
            </>
        );
    }
}

DbView.propTypes = {
    caseId: PropTypes.number,
    dbViewTableData: PropTypes.object,
};


export default DbView;